import { AlingString, ColorsString, GameFontStylesString, textFontSize } from "../../settings/game-constants-strings/text-styles-string";
import { GameElementSpecificationsInterface } from "./../../interfaces/game-element-specifications-interface";

export const mainSceneElementSpecifictions: GameElementSpecificationsInterface[] = [
    {
        type: 'image',
        element: 'background',
        assetName: 'game-scene',
        name: 'scene-background',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 2732,
            objectHeight: 768,
            objectPositionX: 1366,
            objectPositionY: 384,
        }
    },
    {
        type: 'image',
        element: 'background',
        assetName: 'modal-scene-background',
        name: 'scene-modal-backgroud',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 1366,
            objectHeight: 770,
            objectPositionX: 683,
            objectPositionY: 384,
        }
    },
    {
        type: 'image',
        element: 'background',
        assetName: 'ball-background',
        name: 'ball-background',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 80,
            objectHeight: 80,
            objectPositionX: 300,
            objectPositionY: 429,//425
        }
    },
    /*********************************** */
    {
        type: 'sprite',
        element: 'static',
        assetName: 'pipe-background',
        name: 'pipe-background',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 125,
            // objectHeight: 400,
            objectHeight: 390,
            objectPositionX: 300,
            objectPositionY: 648,
        }
    },
    {
        type: 'text',
        element: 'title',
        content: 'PUNTOS: 0',
        name: 'total-score',
        style: {
            fontFamily: GameFontStylesString.BASE_FONT,
            color: ColorsString.DARK_PURPLE_HEXADECIMAL_STRING,
            align: AlingString.RIGHT_STRING,
            stroke: ColorsString.WHITE_HEXADECIMAL_STRING,
            strokeThickness: textFontSize.Regular.strokeThickness,
            fontSize: textFontSize.Regular.fontSize,
        },
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 450,
            objectHeight: 50,
            objectPositionX: 1300,
            objectPositionY: 50,
        },
        originX: 1,
        originY: 0
    }
]